import loadable from "@loadable/component";

const AsyncCalendarContainer = loadable(() =>
  import("../../containers/CalendarContainer")
);

const AsyncTimeContainer = loadable(() =>
  import("../../containers/TimeContainer")
);

const AsyncStatisticPageContainer = loadable(() =>
  import("../../containers/Dashboard/StatisticContainer")
);

// const AsyncDailyAnalysisContainer = loadable(() =>
//   import("../../containers/Dashboard/DailyAnalysisContainer")
// );

// const AsyncUserAnalysisContainer = loadable(() =>
//   import("../../containers/Dashboard/UserAnalysisContainer")
// );

const AsyncPayrollContainer = loadable(() =>
  import("../../containers/Dashboard/PayrollContainer")
);

const AsyncJobTypeSettingContainer = loadable(() =>
  import("../../containers/Setting/JobTypeSettingContainer")
);

const AsyncBranchSettingPageContainer = loadable(() =>
  import("../../containers/Setting/BranchSettingContainer")
);

const AsyncHolidaySettingContainer = loadable(() =>
  import("../../containers/Setting/HolidaySettingContainer")
);

const AsyncOrganizationSettingContainer = loadable(() =>
  import("../../containers/Setting/OrganizationSettingContainer")
);

const AsyncQRcodeSettingContainer = loadable(() =>
  import("../../containers/Setting/QRcodeSettingContainer")
);

const AsyncUserBranchSettingContainer = loadable(() =>
  import("../../containers/Setting/UserBranchSettingContainer")
);

const AsyncProfilePasswordContainer = loadable(() =>
  import("../../containers/Profile/ProfilePasswordContainer")
);

const AsyncWorkedShiftContainer = loadable(() =>
  import("../../containers/Profile/WorkedShiftContainer")
);

const AsyncProfilePayrollContainer = loadable(() =>
  import("../../containers/Profile/ProfilePayrollContainer")
);

const AsyncLeaveHistoryContainer = loadable(() =>
  import("../../containers/Profile/LeaveHistoryContainer")
);

const AsyncTeamContainer = loadable(() =>
  import("../../containers/TeamContainer")
);

const AsyncProfileEmergencyContactContainer = loadable(() =>
  import("../../containers/Profile/EmergencyContactContainer")
);

const AsyncLeaveTypeSettingContainer = loadable(() =>
  import("../../containers/Setting/LeaveTypeSettingContainer")
);

const AsyncPayrollSettingContainer = loadable(() =>
  import("../../containers/Payroll/PayrollSettingContainer")
);

const AsyncPayrollUserContainer = loadable(() =>
  import("../../containers/Payroll/PayrollUserContainer")
);

const AsyncPayrollUserDetailContainer = loadable(() =>
  import("../../containers/Payroll/PayrollUserDetailContainer")
);

const AsyncPayrollConversionContainer = loadable(() =>
  import("../../containers/Payroll/PayrollConversionContainer")
);

const AsyncWriteNewReportsContainer = loadable(() =>
  import("../../containers/DailyReport/WriteNewReportsContainer")
);

const AsyncAllDailyReportsContainer = loadable(() =>
  import("../../containers/DailyReport/AllDailyReportsContainer")
);

const AsyncTemplateDailyReportContainer = loadable(() =>
  import("../../containers/Setting/TemplateDailyReportContainer")
);

export {
  AsyncCalendarContainer,
  AsyncTimeContainer,
  AsyncStatisticPageContainer,
  // AsyncDailyAnalysisContainer,
  // AsyncUserAnalysisContainer,
  AsyncPayrollContainer,
  AsyncJobTypeSettingContainer,
  AsyncBranchSettingPageContainer,
  AsyncHolidaySettingContainer,
  AsyncOrganizationSettingContainer,
  AsyncQRcodeSettingContainer,
  AsyncUserBranchSettingContainer,
  AsyncProfilePasswordContainer,
  AsyncWorkedShiftContainer,
  AsyncProfilePayrollContainer,
  AsyncLeaveHistoryContainer,
  AsyncTeamContainer,
  AsyncProfileEmergencyContactContainer,
  AsyncLeaveTypeSettingContainer,
  AsyncPayrollSettingContainer,
  AsyncPayrollUserContainer,
  AsyncPayrollUserDetailContainer,
  AsyncPayrollConversionContainer,
  AsyncWriteNewReportsContainer,
  AsyncAllDailyReportsContainer,
  AsyncTemplateDailyReportContainer,
};
